import React, { useEffect, useLayoutEffect, useState } from 'react';
import DataModelListDumb from './DataModelListDumb';
import queryString from 'query-string';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useUser, useList, useDataModel } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { Alert, ModalAlert, ErrorScreen } from 'components/common';
import withRequest from 'hoc/withRequest';
import { ROUTES } from 'consts';


const DataModelListSmart = (props) => {
  const { parameters, filters, setFilters } = useUser();
  const projects = formatProjectItems(parameters);
  const projectsMap = projects.reduce((a, v) => ({ ...a, [v.value]: v}), {});
  const { getContentList, content, error, isLoaded } = useList('dataModels');
  const dataModel = useDataModel();
  const history = useHistory();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [dataModelSelected, setDataModelSelected] = useState(null);
  let { project=filters.project } = queryString.parse(props.location.search);

  const handleListPage = () => {
    if (project !== filters.project) setFilters({ project });
    if (project && !!projectsMap[project]) {
      getContentList({
        query: {
          baseUrl: projectsMap[project].base_url
        },
      });
    } else history.push(`?project=${projects[0].value}`);
  };

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.DATA_MODEL_LIST}?project=${data.project}`;
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleCreate = () => {
    history.push(ROUTES.DATA_MODEL_CREATE);
  };

  const handleEdit = (dataModel) => {
    const { value } = dataModel;
    history.push(`${ROUTES.DATA_MODEL_EDIT}/${project}/${value}`);
  };

  const handleView = (dataModel) => {
    const { value } = dataModel;
    history.push(`${ROUTES.DATA_MODEL_VIEW}/${project}/${value}`);
  };

  const handleDelete = () => {
    const { value } = dataModelSelected;
    dataModel.deleteDataModel({
      body: {
        baseUrl: projectsMap[project].base_url,
        f: value
      },
    });
    setOpenModal(false);
  };

  const handleModalDelete = (dataModel) => {
    setDataModelSelected(dataModel);
    setOpenModal(true);
  };

  const alerts = [
    {
      severity: 'success',
      open: dataModel.success.post,
      message: 'dataModelList.components.alert.success',
    },
    {
      severity: 'success',
      open: dataModel.success.delete,
      message: 'dataModelList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: dataModel.success.put,
      message: 'dataModelList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: dataModel.error.put,
      message: 'dataModelList.components.alert.error',
    },
    {
      severity: 'error',
      open: dataModel.error.delete,
      message: 'dataModelList.components.alert.error',
    },
    {
      severity: 'error',
      open: dataModel.error.post,
      message: 'dataModelList.components.alert.error',
    },
  ];

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  useLayoutEffect(() => {
    dataModel.cleanUp();
    if (filters.project) handleSearch({ project: filters.project });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      dataModel.success.get ||
      dataModel.success.post ||
      dataModel.success.put ||
      dataModel.success.delete
    ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dataModel.success.get,
    dataModel.success.post,
    dataModel.success.put,
    dataModel.success.delete,
  ]);

  return (
    <>
      { (error) ? (
        <ErrorScreen />
      ) : (
        <DataModelListDumb
          handleSearch={handleSearch}
          handleCreate={handleCreate}
          handleView={handleView}
          handleEdit={handleEdit}
          handleDelete={handleModalDelete}
          content={content}
          options={projects}
          isLoaded={isLoaded}
          defaultValues={{
            project: !project ? projects[0].value : project,
          }}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => dataModel.cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleDelete}
      />
    </>
  );
};

export default withRequest(withRouter(DataModelListSmart));
